import { useEffect, useState } from 'react';

import { useDropzone } from 'react-dropzone';
import { useDispatch } from 'react-redux';
import { generatePath, useNavigate } from 'react-router-dom';

import { MAX_SIZE_MB } from '@/config';
import transactionModel from '@/models/transaction';
import routes from '@/routes';
import { setIsModalErrorOpen, setModalErrorCode } from '@/store/myDocuments';
import { showError } from '@/utils';
import { IMAGE_MIMES, imageToPdfBytes, pdfBytesToFile } from '@/utils/upload';

import { ERRORS } from './UploadPDF';
import { ACCEPTED_MIME_TYPES_BY_EXTENSIONS, MAX_FILES } from './utils';

export function useUploadPdf(inputRef) {
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	async function handleDrop(file) {
		if (!file) {
			if (inputRef?.current) {
				inputRef.current.value = null;
			}
			return;
		}

		setLoading(true);

		try {
			let pdfFile = file;

			if ([IMAGE_MIMES.jpg, IMAGE_MIMES.png].includes(file?.type)) {
				const pdfBytes = await imageToPdfBytes(file);

				pdfFile = pdfBytesToFile(pdfBytes, file.name);
			}

			const transaction = await transactionModel.uploadPdf(
				pdfFile,
				file.name
			);
			navigate(generatePath(routes.editor, { id: transaction.id }));
		} catch (error) {
			showError(error);
		} finally {
			setLoading(false);
		}
	}

	const { getInputProps, fileRejections } = useDropzone({
		maxFiles: MAX_FILES,
		accept: ACCEPTED_MIME_TYPES_BY_EXTENSIONS,
		maxSize: MAX_SIZE_MB * 1024 * 1024,
		async onDrop([file]) {
			handleDrop(file);
		}
	});

	useEffect(() => {
		if (fileRejections.length) {
			const code = ERRORS[fileRejections[0].errors[0].code] || '';

			dispatch(setModalErrorCode(code));
			dispatch(setIsModalErrorOpen(true));
		}
	}, [fileRejections]);

	return {
		handleDrop,
		getInputProps,
		loading
	};
}
